<template>
  <div class="uk-container" uk-height-viewport>
    <div class="uk-child-width-1-1 uk-child-width-1-2@m uk-flex-center uk-text-center" uk-grid>
      <div class="uk-flex-first">
        <SignUp/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SignUp from '@/components/SignUp.vue'
export default {
  name: 'Home',
  components: {
    SignUp
  }
}
</script>
